import { render } from "./platform.vue?vue&type=template&id=31e190cc&scoped=true&ts=true"
import script from "./platform.vue?vue&type=script&lang=ts&config=true"
export * from "./platform.vue?vue&type=script&lang=ts&config=true"

import "./platform.vue?vue&type=style&index=0&id=31e190cc&scoped=true&lang=css"
import "./platform.vue?vue&type=style&index=1&id=31e190cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e190cc"]])

export default __exports__